import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { class: "schedule-detail" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "schedule-detail" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "schedule-detail" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "schedule-detail" }
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 0,
  class: "schedule-detail"
}
const _hoisted_11 = { class: "text-success" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_ctx.scheduleData && _ctx.scheduleData.hasSchedule)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (
        !_ctx.jobPageStore.projectExecutionsEnabled || !_ctx.scheduleData.executionEnabled
      )
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "scheduletime disabled has_tooltip text-secondary",
              "data-toggle": "tooltip",
              "data-container": "#section-content",
              "data-placement": "auto bottom",
              title: _ctx.$t('disabled.schedule.run')
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("i", { class: "glyphicon glyphicon-pause" }, null, -1)),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("disabled")), 1)
            ], 8, _hoisted_1))
          : (_ctx.scheduleData.executionEnabled && !_ctx.scheduleData.scheduleEnabled)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "scheduletime disabled has_tooltip text-secondary",
                title: _ctx.$t('scheduleExecution.schedule.disabled'),
                "data-toggle": "tooltip",
                "data-container": "#section-content",
                "data-placement": "auto bottom"
              }, [
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "glyphicon glyphicon-pause" }, null, -1)),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("never")), 1)
              ], 8, _hoisted_3))
            : (
        _ctx.scheduleData.scheduleEnabled && !_ctx.jobPageStore.projectSchedulesEnabled
      )
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "scheduletime disabled has_tooltip text-secondary",
                  title: _ctx.$t('project.schedule.disabled'),
                  "data-toggle": "tooltip",
                  "data-container": "#section-content",
                  "data-placement": "auto bottom"
                }, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "glyphicon glyphicon-pause" }, null, -1)),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("never")), 1)
                ], 8, _hoisted_5))
              : (!_ctx.scheduleData.nextExecutionTime)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 3,
                    class: "scheduletime willnotrun has_tooltip text-warning",
                    title: _ctx.$t('job.schedule.will.never.fire'),
                    "data-toggle": "tooltip",
                    "data-container": "#section-content",
                    "data-placement": "auto bottom"
                  }, [
                    _cache[3] || (_cache[3] = _createElementVNode("i", { class: "glyphicon glyphicon-time" }, null, -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("never")), 1)
                  ], 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("span", {
                    key: 4,
                    class: "scheduletime",
                    title: _ctx.title
                  }, [
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "glyphicon glyphicon-time text-success" }, null, -1)),
                    (_ctx.scheduleData && _ctx.scheduleData.nextExecutionTime)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createVNode(_component_i18n_t, {
                            keypath: "schedule.time.in.future",
                            tag: "span",
                            class: "text-secondary"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatDurationFromNowMomentHumanize(
                _ctx.scheduleData["nextExecutionTime"],
              )), 1)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_9))
      ], 64))
    : _createCommentVNode("", true)
}